import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FIELDS, STEPS } from "../utils/constants";
import { useFormStateContext } from "../utils/hooks";
import {
  AvForm,
  AvField,
  AvGroup,
  AvInput,
  AvFeedback,
} from "availity-reactstrap-validation";
import { CiMail } from "react-icons/ci";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { CiUser } from "react-icons/ci";

import {
  InputField,
  InputError,
  InputContainer,
  InputLabel,
  Flex,
  Button,
  ApplicationRootStyles,
} from "../utils/styles";
import axios from "axios";

import { defaultFields } from "../utils/constants";
import offer from "../images/offer-image.png";
import config from "../../commonconfig";
import { userService } from "../../redux/auth/services";
import { loginUser } from "../../redux/actions";
import LoginModal from "../../components/LoginModal";
import { RxCross2 } from "react-icons/rx";
import SmallLoader from "../../components/SmallLoader/SmallLoader";
import { useTranslation } from "react-i18next";

const isTrue = true;
const newVariable = isTrue ? "Its true" : "Its false";

const baseURL2 = "/wallet/usercheck";
const baseURL = "/signup";

// const baseURL2 = "http://localhost:8004/api/wallet/usercheck";
// const baseURL = "http://localhost:8004/api/signup";

// const baseURL2 = " /api/wallet/usercheck";
// const baseURL = "/api/signup";

// const baseURL1 = "http://fantasy.tecpiniondev.com/dosignup";

// const baseURL1 = "/dosignup";

const getCmsApiUrl = config.site.apiUrl + "/get-cms-list";
const redirctUrl = config.site.appUrl;
// const getCmsApiUrl = "http://localhost:8004/api/get-cms-list";
// const redirctUrl = "http://localhost:8004/";

const username_exist = "Username already exist";

const message = "Username already exist";

export const PrivacyConsent = ({
  onRegisterSuccess,
  setIsRegisterModalOpen,

  setIsNextModalOpen,
  openLoginModal,
}) => {
  const { fields, setStep, updateFields } = useFormStateContext();
  const { loading } = useSelector((state) => state.Auth);

  const {
    register,

    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...fields.contact,
       marketingAgree: true, 
    termsAgree: false, 
    },
  });

  const goBack = () => {
    setStep(STEPS.MOBILE);
  };
  const [emailExistMessage, checkEmailExist] = React.useState([]);
  const [bonusCodeMessage, BonusCode] = React.useState([]);
  const [currencyList, setCurrunciesData] = React.useState([]);

  const [emailChecked, setEmailChecked] = useState(1);
  const [smsChecked, setSmsChecked] = useState(1);
  const [phoneChecked, setPhoneChecked] = useState(1);
  const [postChecked, setPostChecked] = useState(1);
  const [privacyconsent, setPrivacyconsent] = useState(false);
  const dispatch = useDispatch();
  const [nickname, setNickname] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [wyntaClickId, setWyntaClickId] = useState(null);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const handleValidSubmit = (event, values) => {
    dispatch(
      loginUser(
        values.username,
        values.password,
        values.nickname,
        values.currency
      )
    );
  };
  const [currency] = useState(["$", "€", "₹", "£"]);

  // const [currencyList] = useState([
  //   { symbol: "$", code: "USD" },
  //   { symbol: "€", code: "eur" },
  //   { symbol: "₹", code: "inr" },
  //   { symbol: "£", code: "gbp" },
  // ]);

  const checkEmailExistence = "/check-email-existence";

  const onSubmit = async (data) => {
    try {
      const res = await axios.post(
        `${config.site.apiUrl}${checkEmailExistence}`,
        {
          email: data.email,
        }
      );

      if (res.data.success === false) {
        checkEmailExist(res.data.message);
        return;
      }

      updateFields(FIELDS.CONTACT, data);
      updateFields(FIELDS.PRIVACYCONSENT, data.privacyconsent);

      createPost(data);

      const submittedConsent = data.privacyconsent;
      const savedConsent = fields.privacyconsent;

      if (submittedConsent !== savedConsent) {
        //  console.log(setIsRegisterModalOpen, 'openmodal')
      } else {
        console.log("Nothing changed or already same consent");
      }
    } catch (err) {
      console.error("Error during form submission:", err);
    }
  };
  const [cmsList, setPostcms] = React.useState([]);

  const onError = (errors, event) => {
    console.log(errors);
    console.log(event);
  };

  const [post, setPost] = React.useState(null);

  const getOpretorCurruncies = async () => {
    try {
      const response = await userService.getCurruncies();
      let data = response.data;
      // setIsLoading(false);
      setCurrunciesData(data);
    } catch (error) {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    getOpretorCurruncies();
  }, []);

  const obj = {
    phonePromotion: phoneChecked,
    postPromotion: postChecked,
    smsPromotion: smsChecked,
    emailPromotion: emailChecked,
    privacyconsent:
      emailChecked && smsChecked && phoneChecked && postChecked ? "all" : "",
  };

  useEffect(() => {
    const allSelected =
      emailChecked && smsChecked && phoneChecked && postChecked;
    setPrivacyconsent(allSelected);
  }, [emailChecked, smsChecked, phoneChecked, postChecked]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const wyntaClickId = urlParams.get("clickid");

    if (wyntaClickId) {
      // Store it temporarily in React state 
      setWyntaClickId(wyntaClickId);
      localStorage.setItem("clickid", wyntaClickId);

    }
  }, []);

  async function createPost(data, obj) {
    // const wyntaClickId = localStorage.getItem("wynta_clickid"); 

    var obj = {};
    obj["first_name"] = fields.contact.firstName;
    obj["last_name"] = fields.contact.lastName;
    obj["code"] = fields.contact.code;
    obj["day"] = fields.contact.day;
    obj["month"] = fields.contact.month;
    obj["year"] = fields.contact.year;
    obj["click_id"] = fields.contact.click_id;
    // obj["phonePromotion"] = fields.contact.phonePromotion;
    // obj["postPromotion"] = fields.contact.postPromotion;
    obj["privacyconsent"] = privacyconsent;
    // obj["smsPromotion"] = fields.contact.smsPromotion;
    obj["phonePromotion"] = phoneChecked;
    obj["postPromotion"] = postChecked;
    obj["emailPromotion"] = emailChecked;
    // obj["privacyconsent"] = privacyconsent;
    obj["smsPromotion"] = smsChecked;
    // obj["currency"] = data.currency;
    obj["currency"] = data.currency || "EUR";
    // obj["currency"] = "eur";

    obj["gender"] = fields.contact.gender;
    obj["country"] = fields.contact.country;
    obj["phone"] = fields.contact.phone;
    obj["address"] = data.address;
    obj["post_code"] = data.post_code;
    obj["code"] = data.code;
    obj["email"] = data.email;
    obj["username"] = data.username;
    obj["password"] = data.password;
    obj["age18+"] = "true";

    if (wyntaClickId) {
      obj["clickid"] = wyntaClickId;
    }
    const clickId = localStorage.getItem("clickid");
    if (clickId) {
      obj["clickid"] = clickId;
    }

    try {
      const response = await axios.post(`${config.site.apiUrl}${baseURL}`, obj);
      setPost(response.data);
      checkEmailExist();
      BonusCode();
      console.log("Response data:", response.data.success);
      if (response.data.success == true) {
        // response.data.message;
        localStorage.removeItem("clickid");
        dispatch(loginUser(data.email, data.password, data.username));
        setIsRegisterModalOpen(false);
        setIsNextModalOpen(true);
        setStep(STEPS.SUCCESS);
      } else if (
        response.data.message === "The bonus code you entered is not valid."
      ) {
        BonusCode(response.data.message);
      } else {
        checkEmailExist(response.data.message);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  }

  const msg = "response.data.message";

  const [response, setPost1] = React.useState(null);

  const [age, setAge] = useState(message);
  const { t, i18n } = useTranslation();

  return (
    <>
      <div className="base-form base-form2">
        <form onSubmit={handleSubmit(onSubmit, onError)} className="form">
          <div className="outer-container">
            <div className="first-container">
              <img src="/images/slotngobg.png" />
            </div>
            <div className="second-container">
              <div className="account__form__wrapper mobile-view-login">
                <div className="second2">
                  <div className="imagelogo">
                    <img src="/images/logo.png" className="login" />
                  </div>
                  <div className="heading">
                    <h3 className="heading3"> {t(`register.register`)}</h3>{" "}
                  </div>{" "}
                </div>

                {/* <p className='mandatory'> Fields with <span className='span-class'>*</span>are mandatory</p> */}

                <div className="">
                  {/* <label  className="name">Nickname</label> */}
                </div>
                <div className="mandatory1">
                  <p>
                    {t(`register.allFields`)}
                    <span style={{ color: "red" }}>&nbsp;*</span>
                  </p>
                </div>
                <InputContainer
                  className="input-container-margin"
                  error={errors.username}
                >
                  {/* <Flex alignItems="center" justifyContent="space-between">
                    {errors.username && (
                      <InputError>{errors.username.message}</InputError>
                    )}
                  </Flex> */}
                  <Flex alignItems="center" justifyContent="space-between">
                    <InputLabel children="" />
                    {errors.username && (
                      <InputError children={errors.username.message} />
                    )}
                  </Flex>
                  <div className="input-icon-wrapper">
                    <InputField
                      id="username"
                      type="text"
                      placeholder={t(`register.nickname`)}
                      style={{ color: "#DEDEDE" }}
                      {...register("username", {
                        required: t('register.validation.nicknameRequired'),
                      })}
                    />
                    <CiUser className="input-icon1" />
                  </div>
                </InputContainer>

                {/* <label className="name">Email</label> */}
                <InputContainer
                  className="input-container-margin"
                  error={errors.email}
                >
                  <Flex alignItems="center" justifyContent="space-between">
                    <InputLabel children="" />
                    {errors.email && (
                      <InputError children={errors.email.message} />
                    )}
                    {!errors.email && emailExistMessage && (
                      <InputError children={emailExistMessage} />
                    )}
                  </Flex>
                  <div className="input-icon-wrapper">
                    <InputField
                      id="email"
                      type="email"
                      placeholder={t(`register.email`)}
                      style={{ color: "#ffff" }}
                      {...register("email", {
                        required: t('register.validation.emailRequired'),
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
                          message: t('register.validation.emailInvalid')
                        }
                      })}
                    />
                    <CiMail className="input-icon1" />
                  </div>

                  {/* <label className='name'>Full Name</label>
              <Flex alignItems="center" justifyContent="space-between">

                <InputLabel htmlFor="firstName" children="" />
                {errors.firstName && (
                  <InputError children={errors.firstName.message} />
                )}
              </Flex>
              <InputField
                id="firstName"
                placeholder='joe taylor'
                {...register('firstName', {
                  required: 'Name required',
                })}
              /> */}
                </InputContainer>

                {/* <label className="name">Password</label> */}
                <InputContainer
                  className="input-container-margin"
                  error={errors.password}
                >
                  <Flex alignItems="center" justifyContent="space-between">
                    <InputLabel htmlFor="" children="" />
                    {errors.password && (
                      <InputError children={errors.password.message} />
                    )}
                  </Flex>
                  <div className="input-icon-wrapper">
                    <InputField
                      id="password"
                      // type="password"
                      minLength={6}
                      type={passwordVisible ? "text" : "password"}
                      placeholder={t(`register.password`)}
                      onChange={(e) => setPassword(e.target.value)}
                      style={{ color: "#DEDEDE" }}
                      {...register("password", {
                        required: t('register.validation.passwordRequired'),
                        pattern: {
                          message: "Invalid password number",
                          // value: /^\d{8}$/,
                        },
                      })}
                    />
                    <span
                      onClick={togglePasswordVisibility}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",

                        color: "#DEDEDE",
                        padding: "5px",
                        fontSize: "15px",
                      }}
                    >
                      {passwordVisible ? <FaRegEye /> : <FaRegEyeSlash />}
                    </span>
                  </div>
                </InputContainer>

                {/* <InputContainer className="input-container-margin">
                  <div className="form-group">
                    <Flex alignItems="center" justifyContent="space-between">
                      <InputLabel htmlFor="" children="" />
                      {errors.currency && (
                        <InputError children={errors.currency.message} />
                      )}
                    </Flex>

                    {!(
                      currencyList.length === 1 &&
                      currencyList[0].code === "EUR"
                    ) && (
                      <select
                        name="currency"
                        id="currency"
                        className="sc-dsLQwm lloepC a-dJxt"
                        required
                        {...register("currency", {
                          required: "currency is required",
                        })}
                      >
                        <option
                          style={{ color: "#DEDEDE" }}
                          className="currency"
                          value=""
                        >
                          Select Currency
                        </option>
                        {currencyList.map((item, index) => (
                          <option
                            key={index}
                            value={item.code}
                            className="option"
                          >
                            {item.symbol}
                          </option>
                        ))}
                      </select>
                    )}

                    {errors.month && (
                      <InputError children={errors.month.message} />
                    )}
                  </div>
                </InputContainer> */}

                <label className="parent">
                  <input
                    type="checkbox"
                    //  className="custom-checkbox"
                    {...register("marketingAgree", {
                      required: t('register.validation.agreeRequired'),
                    })}
                    // onChange={(e) => setPrivacyconsent(e.target.checked)}
                  />
                  <p className="pera-accept">
                    {t(`register.accept`)} {" "}
                    <span className="" style={{ color: "#00bcf7" }}>
                      {t(`register.marketing`)}
                    </span>
                  </p>
                </label>

                {errors.marketingAgree && (
                  <p style={{ color: "red", fontSize: "14px" }}>
                    {errors.marketingAgree.message}
                  </p>
                )}

                <label className="parent">
                  <input
                    type="checkbox"
                    // className="custom-checkbox"
                    {...register("termsAgree", {
                      required: t('register.validation.agreeRequired'),
                    })}
                  />
                  <div className="pera">
                    <p className="">
                      {t(`register.ageAccept`)} {" "}
                      <span className="span-accept">{t(`register.general`)}</span>
                    </p>
                    <p>
                      <span className="span-accept">
                        {" "}
                        {t(`register.terms`)} &nbsp;
                      </span>
                      {t(`register.and`)}<span>&nbsp; {t(`register.privacyPolicy`)}</span>
                    </p>
                  </div>
                </label>

                {errors.termsAgree && (
                  <p style={{ color: "red", fontSize: "14px" }}>
                    {errors.termsAgree.message}
                  </p>
                )}

                {/* <Button children="Next">
            Register 
                
              </Button> */}
                <div className="button-next">
                  <button
                    class="custom-login2"
                    type="submit"
                    disabled={loading}
                  >
                    {t(`register.register`)}
                  </button>
                </div>
                {loading && <SmallLoader />}

                <div className="divider-with-text">
                  <span className="divider-text">{t(`register.or`)}</span>
                </div>
                <div class="term">
                  <p className="text-center">{t(`register.haveAccount`)}</p>
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#00bcf7",
                      fontWeight: 400,
                    }}
                    onClick={openLoginModal}
                  >
                    {t(`loginPop.login`)}
                  </span>{" "}
                  {t(`register.here`)}
                </div>

                {/* <div class="terms5">
              <p className="text-center">
                {" "}
                <a href="/login">Already have an account? </a>{" "}
              </p>
            </div> */}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>

    // <div className="base-form base-form2">
    //   <form onSubmit={handleSubmit(onSubmit, onError)}>
    //     <div className="button-back">
    //       <Button
    //         type="button"
    //         children="Back"
    //         secondary
    //         style={{ margin: "0 10px" }}
    //         onClick={goBack}
    //       >
    //         <i class="fa-solid fa-arrow-left"></i>
    //       </Button>
    //       <h4>Enter Your </h4>
    //       <div className="step-num">
    //         {/* <h4>3/3</h4> */}
    //       </div>
    //     </div>
    //     <div className="f-container">
    //       <label className="name">Email</label>
    //       <InputContainer
    //         style={{ margin: "0px 0 20px 0" }}
    //         error={errors.email}
    //       >
    //         <Flex alignItems="center" justifyContent="space-between">
    //           <InputLabel children="" />
    //           {errors.email && <InputError children={errors.email.message} />}
    //           {!errors.email && emailExistMessage && (
    //             <InputError children={emailExistMessage} />
    //           )}
    //         </Flex>
    //         <InputField
    //           id="email"
    //           type="email"
    //           placeholder="abcd@gmail.com"
    //           {...register("email", {
    //             required: "Email is required",
    //           })}
    //         />

    //         {/* <label className='name'>Full Name</label>
    //           <Flex alignItems="center" justifyContent="space-between">

    //             <InputLabel htmlFor="firstName" children="" />
    //             {errors.firstName && (
    //               <InputError children={errors.firstName.message} />
    //             )}
    //           </Flex>
    //           <InputField
    //             id="firstName"
    //             placeholder='joe taylor'
    //             {...register('firstName', {
    //               required: 'Name required',
    //             })}
    //           /> */}
    //       </InputContainer>

    //       <label className="name">Password</label>
    //       <InputContainer
    //         style={{ margin: "0px 0 20px 0" }}
    //         error={errors.password}
    //       >
    //         <Flex alignItems="center" justifyContent="space-between">
    //           <InputLabel htmlFor="" children="" />
    //           {errors.password && (
    //             <InputError children={errors.password.message} />
    //           )}
    //         </Flex>
    //         <InputField
    //           id="password"
    //           type="password"
    //           minLength={6}
    //           placeholder="Password"
    //           {...register("password", {
    //             required: "password is required",
    //             pattern: {
    //               message: "Invalid password number",
    //               // value: /^\d{8}$/,
    //             },
    //           })}
    //         />
    //       </InputContainer>
    //       <InputContainer style={{ margin: '0px 0 20px 0' }}>
    //         <div className="form-group">
    //           {/* <InputLabel htmlFor="month" children="Month" /> */}
    //           <label
    //             style={{ margin: "0px 0 4px 0" }}
    //             className="name">Currency</label>
    //           <select
    //             name="currency"
    //             id="currency"
    //             className="form--control form-control style--two selector-item_label"
    //             required
    //             {...register('currency')}
    //           >
    //             <option style={{ background: "#fff", color: "#000" }} value="">
    //               Select Currency
    //             </option>
    //             {currencyList.map((item, index) => (
    //               <option
    //                 key={index}
    //                 value={item.code} // 🔁 actual value (like 'usd')
    //                 style={{ background: "#fff", color: "#000" }}
    //               >
    //                 {item.symbol} {/* UI display */}
    //               </option>
    //             ))}
    //           </select>

    //           {errors.month && (
    //             <InputError children={errors.month.message} />
    //           )}
    //         </div>
    //       </InputContainer>

    //       {/* <label className="name">Address</label>
    //       <InputContainer
    //         style={{ margin: "0 0 20px 0" }}
    //         error={errors.address}
    //       >
    //         <Flex alignItems="center" justifyContent="space-between">
    //           <InputLabel htmlFor="" children="" />
    //           {errors.address && (
    //             <InputError children={errors.address.message} />
    //           )}
    //         </Flex>
    //         <InputField
    //           id="address"
    //           type="text"
    //           placeholder="Address"
    //           {...register("address", {
    //             pattern: {
    //               message: "Select the address",
    //             },
    //           })}
    //         />
    //       </InputContainer>

    //       <label className="name">Postcode</label>
    //       <InputContainer
    //         style={{ margin: "0 0 20px 0" }}
    //         error={errors.post_code}
    //       >
    //         <Flex alignItems="center" justifyContent="space-between">
    //           <InputLabel htmlFor="" children="" />
    //           {errors.post_code && (
    //             <InputError children={errors.post_code.message} />
    //           )}
    //         </Flex>
    //         <InputField
    //           id="post_code"
    //           type="text"
    //           placeholder="T400rx0"
    //           {...register("post_code", {
    //             pattern: {
    //               message: "Select the post_code",
    //             },
    //           })}
    //         />
    //       </InputContainer>*/}

    //       <label className="name">Bonus code</label>
    //       <input
    //         disabled
    //         style={{
    //           fontSize: "14px",
    //           background: "none",
    //           color: "red",
    //           outline: "none",
    //           border: "none",
    //           width: "60%",
    //           textAlign: "end",
    //         }}
    //         type="text"
    //         id="responseDataInput"
    //       />

    //       <InputContainer style={{ margin: "0 0 20px 0" }} error={errors.code}>
    //         <Flex alignItems="center" justifyContent="space-between">
    //           <InputLabel htmlFor="" children="" />
    //           {errors.code && <InputError children={errors.code.message} />}
    //           {!errors.code && bonusCodeMessage && (
    //             <InputError children={bonusCodeMessage} />
    //           )}
    //         </Flex>
    //         <InputField
    //           id="code"
    //           type="text"
    //           placeholder="Enter Refferal Code"
    //           {...register("code", {})}
    //         />
    //       </InputContainer>

    //       <InputContainer
    //         style={{ margin: "0px 0 20px 0" }}
    //         error={errors.privacyconsent}
    //       >
    //         <Flex alignItems="center" justifyContent="space-between">
    //           <InputLabel htmlFor="" children="" />
    //           {errors.privacyconsent && (
    //             <InputError children={errors.privacyconsent.message} />
    //           )}
    //         </Flex>
    //         <InputField
    //           id="privacyconsent"
    //           name="conditions"
    //           value="all"
    //           type="checkbox"
    //           {...register("privacyconsent", {
    //             // required: 'Terms and conditions is required',
    //             pattern: {
    //               message: "Select the privacyconsent",
    //             },
    //           })}
    //           checked={
    //             emailChecked && smsChecked && phoneChecked && postChecked
    //           }
    //           onChange={() => {
    //             const isChecked =
    //               !emailChecked && !smsChecked && !phoneChecked && !postChecked;
    //             setEmailChecked(isChecked);
    //             setSmsChecked(isChecked);
    //             setPhoneChecked(isChecked);
    //             setPostChecked(isChecked);
    //           }}
    //         />
    //         <label className="terms5" for="privacyconsent">
    //           agree to receive marketing and promotional materials via all
    //           channels or only via
    //         </label>
    //       </InputContainer>
    //       <InputContainer
    //         style={{ margin: "0px 0 20px 0" }}
    //         error={errors.promotion}
    //       >
    //         <Flex alignItems="center" justifyContent="space-between">
    //           <InputLabel htmlFor="promotion" children="" />
    //           {errors.promotion && (
    //             <InputError children={errors.promotion.message} />
    //           )}
    //         </Flex>
    //         <div className="selector">
    //           <div className="selector-item selecotr-item">
    //             <input
    //               type="checkbox"
    //               id="emailPromotion"
    //               name="emailPromotion"
    //               className="selector-item_checkbox"
    //               {...register("emailPromotion")}
    //               checked={emailChecked}
    //               onChange={() => setEmailChecked(!emailChecked)}
    //               value="emailPromotion"
    //             />
    //             <label htmlFor="emailPromotion" className="selector-item_label">
    //               Email
    //             </label>
    //           </div>
    //           <div className="selector-item selecotr-item">
    //             <input
    //               type="checkbox"
    //               id="smsPromotion"
    //               name="smsPromotion"
    //               className="selector-item_checkbox"
    //               {...register("smsPromotion")}
    //               checked={smsChecked}
    //               onChange={() => setSmsChecked(!smsChecked)}
    //               value="smsPromotion"
    //             />
    //             <label htmlFor="smsPromotion" className="selector-item_label">
    //               SMS
    //             </label>
    //           </div>
    //           <div className="selector-item selecotr-item">
    //             <input
    //               type="checkbox"
    //               id="phonePromotion"
    //               name="phonePromotion"
    //               className="selector-item_checkbox"
    //               {...register("phonePromotion")}
    //               checked={phoneChecked}
    //               onChange={() => setPhoneChecked(!phoneChecked)}
    //               value="phonePromotion"
    //             />
    //             <label htmlFor="phonePromotion" className="selector-item_label">
    //               Phone
    //             </label>
    //           </div>
    //           <div className="selector-item selecotr-item">
    //             <input
    //               type="checkbox"
    //               id="postPromotion"
    //               name="postPromotion"
    //               className="selector-item_checkbox"
    //               {...register("postPromotion")}
    //               checked={postChecked}
    //               onChange={() => setPostChecked(!postChecked)}
    //               value="postPromotion"
    //             />
    //             <label htmlFor="postPromotion" className="selector-item_label">
    //               Post
    //             </label>
    //           </div>
    //         </div>
    //       </InputContainer>

    //       <a className="offer-image" href="">
    //         <img src="http://casino.tecpiniondev.com/assets/admin/images/offer-image.png" />
    //       </a>

    //       <div className="for-button-manage">
    //         <form>
    //           <div className="terms5 terms2">
    //             {cmsList.map((item, index) =>
    //               item.is_registration_page_enable == 1 ? (
    //                 <InputContainer error={errors.privacyconsent}>
    //                   <InputField
    //                     id={item.id}
    //                     className="policy"
    //                     name="policy"
    //                     value="policy"
    //                     type="checkbox"
    //                     checked
    //                   />
    //                   <label htmlFor={item.id}>
    //                     {" "}
    //                     {item.title}{" "}
    //                     <a href={redirctUrl + item.slug} target="_blank">
    //                       learn more
    //                     </a>
    //                   </label>
    //                 </InputContainer>
    //               ) : (
    //                 ""
    //               )
    //             )}
    //           </div>
    //         </form>
    //         <div className="button-next">
    //           <Button children="Next">
    //             Finish <span className="enter"></span>{" "}
    //             <i class="fa-solid fa-arrow-right"></i>
    //           </Button>
    //         </div>

    //         <div class="terms5">
    //           <p className="text-center">
    //             {" "}
    //             <a href="/login">Already have an account? </a>{" "}
    //           </p>
    //         </div>
    //       </div>
    //     </div>
    //   </form>
    // </div>

    //     <>
    //       <div>
    //         <div className="outer-container">
    //           <div className="first-container">
    //             <img src="/images/slotngobg.png" />

    //           </div>

    //           <div className="second-container">
    //             <div className="account__form__wrapper mobile-view-login">
    //               <div className="row">
    //                 <div className="col-12">
    //                   <img src="/images/logo.png" className="login" />
    //                   <h3 className="h3_heading">register</h3>
    //                 </div>
    //                 <p className='mandatory'> Fields with <span className='span-class'>*</span>are mandatory</p>
    //               </div>
    //               <AvForm className="" onSubmit={handleSubmit(onSubmit, onError)}>
    //                 <div className="col-12">
    //                   <div className="form-group">
    //                     <div className="input-icon-wrapper">
    //                       <AvField
    //                         id="nickname"
    //                         type="text"
    //                         name="nickname"
    //                         value={nickname}
    //                         className="form--control2 style--two"
    //                         placeholder="Nickname "
    //                         validate={{ required: { value: true, errorMessage: 'Please enter email' } }}
    //                         onChange={(e) => setNickname(e.target.value)}
    //                       />

    //                       <CiUser className="input-icon1" />

    //                     </div>

    //                   </div>
    //                 </div>
    //                 <div className="col-12">
    //                   <div className="form-group">
    //                     <div className="input-icon-wrapper">
    //                       <AvField
    //                         id="username"
    //                         type="text"
    //                         name="username"
    //                         value={username}
    //                         className="form--control2 style--two"
    //                         placeholder="Email "
    //                         validate={{ required: { value: true, errorMessage: 'Please enter email' } }}
    //                         onChange={(e) => setUsername(e.target.value)}
    //                       />

    //                       <CiMail className="input-icon1" />

    //                     </div>

    //                   </div>
    //                 </div>

    //                 <div className="col-12">
    //                   <div className="form-group">
    //                     <div className="form-group" >
    //                       <div className="input-icon-wrapper">
    //                         <AvField
    //                           id="password"
    //                           name="password"
    //                           type={passwordVisible ? 'text' : 'password'}
    //                           className="form--control2 style--two"
    //                           placeholder="Password"
    //                           value={password}
    //                           onChange={(e) => setPassword(e.target.value)}
    //                           validate={{
    //                             required: { value: true, errorMessage: 'Please enter password' },
    //                           }}
    //                         />
    //                         <span
    //                           onClick={() => setPasswordVisible((prev) => !prev)}
    //                           style={{
    //                             position: 'absolute',
    //                             top: '50%',
    //                             right: '10px',
    //                             transform: 'translateY(-50%)',
    //                             cursor: 'pointer',
    //                             zIndex: 5,
    //                             color: '#aaa',
    //                             padding: '5px',
    //                             fontSize: '20px'
    //                           }}
    //                         >
    //                           {passwordVisible ? <FaRegEye /> : <FaRegEyeSlash />}
    //                         </span>

    //                       </div>
    //                     </div> </div>
    //                 </div>

    //                 <div className="col-12">
    //                   <div className="form-group">
    //                     <div className="form-group" >
    //                       <div className="input-icon-wrapper"></div>
    //                       <AvField
    //                         type="select"
    //                         name="currency"

    //                         className="form--control2 style--two"
    //                         required
    //                         errorMessage="Please select a currency"
    //                       >
    //                         <option className="currency"

    //                           value="">
    //                           Select Currency
    //                         </option>
    //                         {currencyList.map((item, index) => (
    //                           <option
    //                             key={index}
    //                             value={item.code}
    //                             className="currency-option"
    //                           >
    //                             {item.symbol}
    //                           </option>
    //                         ))}
    //                       </AvField>

    //                     </div>
    //                   </div>
    //                 </div>

    //                 <div className="flex-wrap flex-sm-nowrap justify-content-between mt-5">
    //                   <Link to="/forget-password" className="forgot">Forgot Password?</Link>
    //                 </div>

    //                <div className="checkbox-wrapper">
    //   <div className="checkbox-item">
    //     <AvField
    //       type="checkbox"
    //       name="agreeMarketing"
    //       required
    //       errorMessage="You must agree before submitting"
    //       className="check"
    //     />
    //     <p className="accept">
    //       I accept <span className="span-accept">Marketing Material</span>
    //     </p>
    //   </div>

    //   <div className="checkbox-item">
    //     <AvField
    //       type="checkbox"
    //       name="agreeNewsletter"
    //       required
    //       errorMessage="You must agree before submitting"
    //       className="check"
    //     />
    //     <p className="accept">
    //       I am 18 years or older and I accept <span  className="span-accept"> General Terms & Conditions  &nbsp;</span >and  <span>Privacy Policy</span>
    //     </p>
    //   </div>
    // </div>

    //                 <div className="col-12">
    //                   <div className="">
    //                     <button className="cstm_btn" type="submit">Register</button>
    //                   </div>
    //                   <div className="divider-with-text">
    //   <span className="divider-text">or</span>

    // </div>

    //                 </div>

    //               </AvForm>
    //             </div>

    //           </div>
    //         </div>

    //       </div>
    //     </>
  );
};
